import {useEffect, useState} from 'react';
import {SelectInput} from '../utils/SelectInput';
import {
  estadosDisabled,
  etapasIdByName,
  oportunidadEstadoDescById,
} from '../utils/constants';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {
  constants,
  getDateUtcOrEmpty,
  prepareDatosAuxOptions,
  responseSelector,
} from '../utils/utils';
import Etiqueta from '../utils/etiquetaObligatorio/Etiqueta';
import {MonedaInputV2} from '../ui/moneda';
import {Alert, alertTypes, useAlerts} from '../ui/alert';
import {CargosPotencialesNotas} from '../candidatos/editar/CargosPotencialesNotas';
import {useDispatch, useSelector} from 'react-redux';
import {log} from '../utils/logs';
import {
  crearCargoPotDuck,
  crearCargoPotThunk,
  getCargosPotDuck,
  getCargosPotThunk,
} from '../candidatos/duck';
import {
  avanzarAEtapaDuck,
  avanzarAEtapaThunk,
  descartarCandidatoDuck,
  descartarCandidatoThunk,
  getCargosDuck,
  getCargosThunk,
  getMotivosDescarteDuck,
  getMotivosDescarteThunk,
  getUsuariosForSelectDuck,
  getUsuariosForSelectThunk,
} from './duck';
import {CheckBox} from '../ui/Checkbox';
import {AgregarExperienciaView} from '../candidatos/AgregarExperienciaView';
const {TextInput} = require('../utils/TextInput');

function AvanzarDeEtapaView({
  onSuccess,
  onError,
  etapasOptions,
  oportunidad,
  candidato,
  etapasById,
  token,
  oportunidadId,
  accion,
}) {
  const dispatch = useDispatch();

  const [tieneExperiencia, setTieneExperiencia] = useState(true);

  const modelGetCargosPot = useSelector(state => state.getCargosPot);
  const modelCrearCargoPot = useSelector(state => state.crearCargoPot);
  const modelGetCargos = useSelector(state => state.getCargos);
  const modelUsuarios = useSelector(state => state.getUsuariosForSelect);
  const [cargosOptions, setCargosOptions] = useState([]);

  const [cargoOption, setCargoOption] = useState();
  const [usuarioOptions, setUsuarioOptions] = useState([]);
  const [usuarioSelected, setUsuarioSelected] = useState({});
  const [cargosPotenciales, setCargosPotenciales] = useState([]);

  const modelAvanzarAEtapa = useSelector(state => state.avanzarAEtapa);
  const modelGetMotivosDescarte = useSelector(
    state => state.getMotivosDescarte,
  );
  const modelDescartarCandidato = useSelector(
    state => state.descartarCandidato,
  );
  const [expectativaSalarial, setExpectativaSalarial] = useState('0');
  const [etapaOption, setEtapaOption] = useState();
  const [etapas, setEtapas] = useState([]);

  const [motivoOption, setMotivoOption] = useState();
  const [motivosOptions, setMotivosOptions] = useState();

  const [titulo, setTitulo] = useState('');

  const [contenido, setContenido] = useState('');

  const [conSupervision, setConSupervision] = useState(false);

  const {setTopAlert, topAlert} = useAlerts();

  const etapaActual = candidato?.etapasIds?.[0];

  const descartadoOInactivo =
    candidato?.etapaInfo?.descartado || candidato?.etapaInfo?.inactivo;
  useEffect(() => {
    let etapasDisponibles = [];

    if (!etapaActual || descartadoOInactivo) {
      etapasDisponibles = etapasOptions;
    } else {
      etapasOptions.forEach(elem => {
        if (elem.value > etapaActual) {
          etapasDisponibles.push(elem);
        }
      });
    }

    if (
      (etapaActual !== etapasIdByName.entrevistaCliente &&
        etapaActual !== etapasIdByName.entrevistaClienteV2) ||
      descartadoOInactivo
    ) {
      const withoutCierre = etapasDisponibles.filter(
        elem =>
          elem.value !== etapasIdByName.cierre &&
          elem.value !== etapasIdByName.cierreV2,
      );
      etapasDisponibles = withoutCierre;
    }
    setEtapas(etapasDisponibles);
  }, [etapaActual]);

  function agregarCargoPot() {
    const data = {
      userToken: token.raw,
      candidatoIdNumerico: candidato.idNumerico,
      cargoIdNumerico: cargoOption?.value,
    };

    log({'agregarCargoPot.data': data});

    dispatch(crearCargoPotThunk(data));
  }

  useEffect(() => {
    dispatch(
      getCargosThunk({
        userToken: token.raw,
      }),
    );

    dispatch(
      getCargosPotThunk({
        userToken: token.raw,
        candidatoIdNumerico: candidato.idNumerico,
      }),
    );

    dispatch(
      getMotivosDescarteThunk({
        userToken: token.raw,
      }),
    );

    dispatch(
      getUsuariosForSelectThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(
      modelGetMotivosDescarte,
    );

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getMotivosDescarteDuck.actions.clear());
    }

    if (data) {
      setMotivosOptions(prepareDatosAuxOptions(data.items));
      dispatch(getMotivosDescarteDuck.actions.clear());
    }
  }, [modelGetMotivosDescarte]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} =
      responseSelector(modelAvanzarAEtapa);

    log('modelAvanzarAEtapa.useEffect');

    if (error) {
      log('modelAvanzarAEtapa.useEffect.error');
      setTitulo('');
      setContenido('');
      onError(errorMessage);
      dispatch(avanzarAEtapaDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      log('modelAvanzarAEtapa.useEffect.success');
      setTitulo('');
      setContenido('');
      onSuccess();
      dispatch(avanzarAEtapaDuck.actions.clear());
    }
  }, [modelAvanzarAEtapa]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(
      modelDescartarCandidato,
    );

    log('modelDescartarCandidato.useEffect');

    if (error) {
      log('modelDescartarCandidato.useEffect.error');
      setTitulo('');
      setContenido('');
      onError(errorMessage);

      dispatch(descartarCandidatoDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      log('modelDescartarCandidato.useEffect.success');
      setTitulo('');
      setContenido('');
      onSuccess();
      dispatch(descartarCandidatoDuck.actions.clear());
    }
  }, [modelDescartarCandidato]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(modelGetCargos);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosDuck.actions.clear());
    }

    if (data) {
      const cargos = data.items;

      const datosAuxOptions = prepareDatosAuxOptions(cargos);

      setCargosOptions(datosAuxOptions);

      dispatch(getCargosDuck.actions.clear());
    }
  }, [modelGetCargos]);

  useEffect(() => {
    const {data, httpStatus, error, errorMessage} =
      responseSelector(modelGetCargosPot);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosPotDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      // log({ 'getCargosPot.data': data });

      dispatch(getCargosPotDuck.actions.clear());
      setCargosPotenciales(data.cargosPotenciales);
      setExpectativaSalarial(data.expectativaSalarial);
      setTieneExperiencia(data.tieneExperiencias);
    }
  }, [modelGetCargosPot]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} =
      responseSelector(modelCrearCargoPot);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(crearCargoPotDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(crearCargoPotDuck.actions.clear());

      dispatch(
        getCargosPotThunk({
          userToken: token.raw,
          candidatoIdNumerico: candidato.idNumerico,
        }),
      );
      setTopAlert({
        text: 'Cargo potencial agregado correctamente',
        type: alertTypes.success,
        closable: false,
      });
    }
  }, [modelCrearCargoPot]);

  function avanzarAEtapa() {
    log({
      'avanzarEtapa.params': {
        candidatoIdNumerico: candidato.idNumerico,
        etapaIdNumerico: etapaOption.value,
      },
    });

    if (conSupervision && !usuarioSelected?.value) {
      setTopAlert({
        text: 'Debe seleccionar un usuario',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }
    dispatch(
      avanzarAEtapaThunk({
        userToken: token.raw,
        candidatoIdNumerico: candidato.idNumerico,
        etapaIdNumerico: etapaOption.value,
        oportunidadIdNumerico: oportunidadId,
        titulo,
        contenido,
        expectativaSalarial,
        companheroId:
          conSupervision && usuarioSelected?.value
            ? usuarioSelected?.value
            : null,
      }),
    );
  }

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelUsuarios);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getUsuariosForSelectDuck.actions.clear());
    }

    if (data) {
      setUsuarioOptions(data?.data);
      dispatch(getUsuariosForSelectDuck.actions.clear());
    }
  }, [modelUsuarios]);

  function descartarCandidato() {
    dispatch(
      descartarCandidatoThunk({
        userToken: token.raw,
        candidatoIdNumerico: candidato.idNumerico,
        oportunidadIdNumerico: oportunidadId,
        motivoDescarteId: motivoOption?.value,
        titulo,
        contenido,
        expectativaSalarial,
        companheroId:
          conSupervision && usuarioSelected?.value
            ? usuarioSelected?.value
            : null,
      }),
    );
  }
  function onErrorExperiencia(msg) {
    setTopAlert({
      text: msg,
      type: alertTypes.danger,
      closable: false,
    });
  }

  function onSuccessExperiencia() {
    setTieneExperiencia(true);
  }

  return (
    <div className="form-group">
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      {!tieneExperiencia && (
        <AgregarExperienciaView
          token={token}
          candidatoIdNumerico={candidato.idNumerico}
          onError={onErrorExperiencia}
          onSuccess={onSuccessExperiencia}
        />
      )}

      {tieneExperiencia && (
        <>
          <Alert
            title="Observacion"
            type={alertTypes.info}
            text="El candidato debe tener al menos 3 cargos potenciales para crear una nota"
            closable={false}
          />
          <h4>Cargos potenciales</h4>
          <h5>
            Para editar o eliminar cargo potenciales acceder a la pantalla de{' '}
            <a
              href={`/editarCandidato/${candidato.idNumerico}`}
              target="_blank"
              rel="noreferrer">
              edicion del usuario
            </a>
          </h5>

          <CargosPotencialesNotas
            agregarCargoPot={agregarCargoPot}
            cargoOption={cargoOption}
            setCargoOption={setCargoOption}
            cargosOptions={cargosOptions}
            modelCrearCargoPot={modelCrearCargoPot}
            modelGetCargosPot={modelGetCargosPot}
            cargosPotenciales={cargosPotenciales}
          />

          <h4>Expectativa salarial</h4>

          <MonedaInputV2
            initialValue={expectativaSalarial}
            setValue={setExpectativaSalarial}
            selectorMonedaDisabled={true}
          />
          <div style={{marginBottom: 10}}>
            <b>Oportunidad</b>
            <br />
            Título: {oportunidad.titulo}
            <br />
            Empresa: {oportunidad.empresaDescripcion}
            <br />
            Estado: {oportunidadEstadoDescById?.[oportunidad.estado] ?? 'N/A'}
            <br />
            Cargo: {oportunidad.cargoDescripcion}
          </div>
          <div style={{marginBottom: 10}}>
            <b>Candidato</b>
            <br />
            Nombre: {candidato.nombreCompleto}
            <br />
            Etapa actual:{' '}
            {etapasById?.[candidato.etapaInfo.etapaIdNumerico]?.descripcion ||
              'N/A'}
            <br />
            Fecha de avance a etapa:{' '}
            {getDateUtcOrEmpty(candidato.etapaInfo.fecha)}
          </div>

          {accion === 'descarte' ? (
            <div>
              <SelectInput
                label="Motivo"
                value={motivoOption}
                options={motivosOptions}
                setValue={setMotivoOption}
              />
            </div>
          ) : null}

          {accion === 'avance' ? (
            <SelectInput
              label="Nueva etapa para candidato"
              value={etapaOption}
              options={etapas}
              setValue={setEtapaOption}
            />
          ) : null}

          <div>
            <h4>Nota</h4>
            <TextInput
              label="Título"
              initialValue={titulo}
              setValue={setTitulo}
            />
            <label>
              <Etiqueta texto="Observación" obligatorio={false} />
            </label>
            <textarea
              className="form-control"
              rows="5"
              value={contenido}
              onChange={evt => setContenido(evt.target.value)}
            />
            <div style={{marginTop: 10}}>
              <CheckBox
                text="Con supervision"
                checked={conSupervision}
                onChange={setConSupervision}
              />
              {conSupervision && (
                <SelectInput
                  label="Usuario"
                  value={usuarioSelected}
                  options={usuarioOptions}
                  setValue={setUsuarioSelected}
                  required
                />
              )}
            </div>
          </div>

          <ButtonWithLoading
            type={accion === 'avance' ? 'success' : 'danger'}
            text={
              accion === 'avance'
                ? 'Avanzar a etapa seleccionada'
                : 'Descartar candidato'
            }
            submit={
              accion === 'avance'
                ? () => avanzarAEtapa()
                : () => descartarCandidato()
            }
            disabled={
              estadosDisabled.includes(oportunidad.estado) ||
              (accion === 'descarte' && !motivoOption?.value) ||
              (accion === 'avance' && !etapaOption?.value)
            }
            loading={
              modelAvanzarAEtapa.loading || modelDescartarCandidato.loading
            }
          />
        </>
      )}
    </div>
  );
}

export {AvanzarDeEtapaView};
